export const SET_FIELD = 'DPT_HAND/SET_FIELD';
export const FETCH_DATA = 'DPT_HAND/FETCH_DATA';
export const FETCH_DATA_SUCCESS = 'DPT_HAND/FETCH_DATA_SUCCESS';
export const FETCH_DATA_ERROR = 'DPT_HAND/FETCH_DATA_ERROR';
export const SAVE = 'DPT_HAND/SAVE';
export const SAVE_SUCCESS = 'DPT_HAND/SAVE_SUCCESS';
export const SAVE_ERROR = 'DPT_HAND/SAVE_ERROR';
export const FETCH_ELEMENT = 'DPT_HAND/FETCH_ELEMENT';
export const FETCH_ELEMENT_SUCCESS = 'DPT_HAND/FETCH_ELEMENT_SUCCESS';
export const FETCH_ELEMENT_ERROR = 'DPT_HAND/FETCH_ELEMENT_ERROR';
export const SET_ACTIVE_PAGE = 'DPT_HAND/SET_ACTIVE_PAGE';
export const RESET_FORM = 'DPT_HAND/RESET_FORM';